import { Item } from "../../items/item.entity";
import { Taxes } from "../../taxes/taxes.entity";
import { Vendors } from "../../vendors/vendors.entity";
import { VendorPriceListDto } from "../dto/vendor-price-list-create.dto";
import { VendorsPriceList } from "../entities/vendor-price-list.entity";

export class VenPriceListAdapter{
   public ConvertDtoToEntity(details:VendorPriceListDto):VendorsPriceList {
        const vendorPriceList = new VendorsPriceList();
        vendorPriceList.unitPrice = details.unitPrice;
        vendorPriceList.discountPercentage = details.discountPercentage;
        vendorPriceList.discountPrice = details.discountPrice;
        vendorPriceList.actualPrice = details.actualPrice;
        vendorPriceList.skuCode = details.skuCode;
        vendorPriceList.items = new Item();
        vendorPriceList.items.itemId = details.itemId;
        vendorPriceList.vendors = new Vendors();
        vendorPriceList.vendors.vendorId = details.vendorId
        vendorPriceList.taxes = new Taxes();
        vendorPriceList.taxes.taxId = details.taxId;
        vendorPriceList.isActive = details.isActive;
        if(details.vendorPriceListId){
            vendorPriceList.vendorPriceListId = details.vendorPriceListId;
            vendorPriceList.updatedUser = details.updatedUser;
        }else{
            vendorPriceList.createdUser = details.createdUser;
        }
        return vendorPriceList;
    }
}